// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlaySquareOutlinedSvg from "@ant-design/icons-svg/es/asn/PlaySquareOutlined";
import AntdIcon from '../components/AntdIcon';

var PlaySquareOutlined = function PlaySquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareOutlinedSvg
  }));
};

PlaySquareOutlined.displayName = 'PlaySquareOutlined';
export default React.forwardRef(PlaySquareOutlined);